import { STUDY_LANDSCAPES, type LandscapeId } from "../data/landscapes";

type LandscapePickerProps = {
  readonly selectedId: LandscapeId;
  readonly onSelect: (id: LandscapeId) => void;
  readonly allowAll?: boolean;
  readonly allSelected?: boolean;
  readonly onSelectAll?: () => void;
};

export function LandscapePicker({
  selectedId,
  onSelect,
  allowAll = false,
  allSelected = false,
  onSelectAll,
}: LandscapePickerProps) {
  return (
    <div className="nbs-story-picker-row" role="group" aria-label="Territoire à explorer">
      {allowAll ? (
        <button
          type="button"
          className="nbs-story-picker-row__btn"
          aria-pressed={allSelected}
          onClick={onSelectAll}
        >
          Ensemble
        </button>
      ) : null}
      {STUDY_LANDSCAPES.map((place) => (
        <button
          key={place.id}
          type="button"
          className="nbs-story-picker-row__btn"
          aria-pressed={!allSelected && selectedId === place.id}
          onClick={() => onSelect(place.id)}
        >
          {place.shortLabel}
        </button>
      ))}
    </div>
  );
}
